/* eslint-disable angular/json-functions */
(function () {

  angular.module('CloudStorageProvider', [])

    .factory('CloudStorageModel', function (Utils, $q, $http) {
      return function (cloudStorageData) {
        const CloudStorageModel = {};
        const CloudStorageModelPrivate = {};

        CloudStorageModel.init = function (cloudStorageData) {
          if (Utils.objectPropertiesCheck(cloudStorageData, ['_links'])) {
            CloudStorageModel.info = angular.copy(cloudStorageData);
            CloudStorageModel.id = CloudStorageModel.info._links.self.href.split('/').pop();
            CloudStorageModel.options = {
              isSelected: false
            };
            CloudStorageModel.customProperties = {};
            CloudStorageModelPrivate.normalizeLinks();
          } else {
            throw String('CloudStorageModel: cloudStorageData is not valid');
          }
        };

        CloudStorageModelPrivate.normalizeLinks = function () {
          angular.forEach(CloudStorageModel.info._links, function (link, index) {
            if (angular.isObject(link) && !angular.isArray(link)) {
              const linkClean = link.href.split('?')[0];
              CloudStorageModel.info._links[index].href = linkClean;
            }
          });
          const selfHrefSplit = CloudStorageModel.info._links.self.href.split('/');
          CloudStorageModel.customProperties.id = selfHrefSplit[selfHrefSplit.length - 1];
        };

        CloudStorageModelPrivate.replaceInfo = function (embeddedKey, data, doNotReplaceEmbeddedAndLinks) {
          if (!CloudStorageModel.info._embedded) {
            CloudStorageModel.info._embedded = {};
          }
          if (embeddedKey) {
            CloudStorageModel.info._embedded[embeddedKey] = angular.copy(data);
          } else {
            const embedded = angular.copy(CloudStorageModel.info._embedded);
            const links = angular.copy(CloudStorageModel.info._links);
            CloudStorageModel.info = angular.copy(data);
            if (!doNotReplaceEmbeddedAndLinks) {
              CloudStorageModel.info._embedded = embedded;
              CloudStorageModel.info._links = links;
            }
            CloudStorageModelPrivate.normalizeLinks();
          }
        };

        CloudStorageModel.saveChanges = function (changedStorage) {
          if (changedStorage) {
            const patchObjectArray = Utils.getObjectsDifferencesForPatching(CloudStorageModel.info, changedStorage.info);
            if (patchObjectArray.length > 0) {
              const defered = $q.defer();
              $http.patch(CloudStorageModel.info._links.self.href, patchObjectArray).then(function (cloudStorage) {
                CloudStorageModel.info = cloudStorage.data;
                CloudStorageModelPrivate.normalizeLinks();
                defered.resolve(CloudStorageModel);
              }).catch(function (error) {
                defered.reject(error);
              });
              return defered.promise;
            } else {
              return $q.resolve();
            }
          }
        };

        CloudStorageModel.changeName = function (newStorageName) {
          const patch = [{
            op: 'replace',
            path: '/name',
            value: newStorageName
          }];
          const defered = $q.defer();
          $http.patch(CloudStorageModel.info._links.self.href, patch).then(function (cloudStorage) {
            CloudStorageModel.info = cloudStorage.data;
            CloudStorageModelPrivate.normalizeLinks();
            defered.resolve(CloudStorageModel);
          }).catch(function (error) {
            defered.reject(error);
          });
          return defered.promise;
        };

        CloudStorageModel.changeKey = function (newStorageKey) {
          const patch = [{
            op: 'replace',
            path: '/key',
            value: CloudStorageModel.info.type === 'S3' ? JSON.stringify(newStorageKey) : newStorageKey
          }];
          const defered = $q.defer();
          $http.patch(CloudStorageModel.info._links.self.href, patch).then(function (cloudStorage) {
            CloudStorageModel.info = cloudStorage.data;
            CloudStorageModelPrivate.normalizeLinks();
            defered.resolve(CloudStorageModel);
          }).catch(function (error) {
            defered.reject(error);
          });
          return defered.promise;
        };

        CloudStorageModel.deleteCloudStorage = function (cloudStorage) {
          const defered = $q.defer();
          const url = cloudStorage.info._links.self.href;
          $http.delete(url).then(function (response) {
            defered.resolve(response);
          }).catch(function (error) {
            defered.resolve(error);
          });
          return defered.promise;
        };

        CloudStorageModel.testCloudStorage = function (cloudStorage) {
          const defered = $q.defer();
          const url = cloudStorage.info._links['px:cloudStoreAccountVerifications'].href;
          $http.post(url).then(function (response) {
            defered.resolve(response);
          }).catch(function (error) {
            defered.resolve(error);
          });
          return defered.promise;
        };

        CloudStorageModel.init(cloudStorageData);
        delete CloudStorageModel.init;
        return CloudStorageModel;
      };
    })

    .service('CloudStorageService', function ($http, $q, TenantListService, CloudStorageModel) {
      const cloudStorageListServiceAsObject = this;
      this.list = [];

      cloudStorageListServiceAsObject.getCloudStorages = function () {
        if (TenantListService.currentTenant) {
          const url = TenantListService.currentTenant.info._links['px:cloudStoreAccounts'].href;
          const defered = $q.defer();
          $http.get(url).then(function (response) {
            const cloudStorageList = [];
            if (response.data._embedded) {
              angular.forEach(response.data._embedded['px:cloudStoreAccountResources'], function (cloudStorage) {
                cloudStorageList.add(new CloudStorageModel(cloudStorage));
              });
            }
            defered.resolve(cloudStorageList);
          }).catch(function (error) {
            defered.reject(error);
          });
          return defered.promise;
        }
      };

      this.connectCloudStorage = function (storageProviderData) {
        const defered = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:cloudStoreAccounts'].href;

        const dataToSend = {
          type: storageProviderData.type,
          name: storageProviderData.name,
          endpointSuffix: storageProviderData.endpointSuffix ? storageProviderData.endpointSuffix : null,
          key: storageProviderData.type === 'S3' ? JSON.stringify(storageProviderData.key) : storageProviderData.key,
          region: storageProviderData.region ? storageProviderData.region : null,
          endpointOverride: storageProviderData.endpointOverride ? storageProviderData.endpointOverride : null,
          active: storageProviderData.active,
          docSources: storageProviderData.documentSources,
          sites: storageProviderData.sites
        };
        $http.post(url, dataToSend).then(function (response) {
          defered.resolve(response);
        }).catch(function (error) {
          defered.reject(error);
        });

        return defered.promise;
      };

      this.setOrderOfCloudStorages = function (order) {
        if (TenantListService.currentTenant) {
          const deferred = $q.defer();
          const url = TenantListService.currentTenant.info._links['px:cloudStoreAccounts'].href + '/updateOrder';
          $http.post(url, { storeIds: order }).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        }
      };

      cloudStorageListServiceAsObject.getCloudStorages();
    });

})();
